import { useWeatherWalls } from './getWeatherWalls';

import { WeatherWallWindowRelations } from 'types';

const removeWallsWithoutFolders = (walls: WeatherWallWindowRelations[]) => {
  return walls.filter((wall) => !wall.folder_id);
};

type UseWallOptions = {
  userId: number | undefined;
};

export const useWeatherWallsWithoutFolders = ({ userId }: UseWallOptions) =>
  useWeatherWalls(userId, (data: WeatherWallWindowRelations[]) =>
    removeWallsWithoutFolders(data)
  );
